import "./style.scss";
import CountryCell from "./CountryCell/CountryCell";
import DateCell from "./DateCell/DateCell";

type BodyColumn = {
  id: string;
  value: string;
};

type CellContentProps = {
  groupKey: string;
  column: BodyColumn;
  onChange: (value: string) => void;
};

const CellContent = ({ groupKey, column, onChange }: CellContentProps) => {
  if (groupKey === "studentInfo" && column.id === "country") {
    return (
      <div className="cell-content country">
        <CountryCell value={column.value} onChange={onChange} groupKey={groupKey} columnID={column.id} />
      </div>
    );
  }

  if (groupKey === "studentInfo" && column.id === "dateOfBirth") {
    return (
      <div className="cell-content date">
        <DateCell value={column.value} onChange={onChange} groupKey={groupKey} columnID={column.id} />
      </div>
    );
  }

  return <p>{column.value}</p>;
};

export default CellContent;
